import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ProgressBar } from "react-bootstrap";
import CarruselImagenes from "./CarruselImagenes";
import FormBusquedaPorDominio from "./Formularios/FormBusquedaPorDominio";
import { renderModal } from "../handlers";
import { Card, MuniSpinner2 } from "../../components";
import { BanIcon, CheckIcon, EyeIcon, FileIcon } from "../../components/Icons";
import encabezado from "/ENCABEZADO-busqueda.jpg";
import { handleIngresoApp, stringMensajePara } from "./handlers";
import { MODE } from "../../config";
import FormGuardarCorreo from "./Formularios/FormGuardarCorreo";
import Captcha from "./Captcha";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalCaptcha from "../../views/modals/ModalCaptcha";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";


const BuscarInfracciones = () => {
  const { modals, loads } = useGeneralAppStore();
  const [infracciones, setInfracciones] = useState([]);
  const [infraccionSeleccionada, setInfraccionSeleccionada] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [valor, setValor] = useState(null);
  const [datosSobre, setDatosSobre] = useState(null);
  const [verify, setVerify] = useState(false)
  const [correoElectronico, setCorreoElectronico] = useState(null);
  const [constancia, setConstancia] = useState(null);
  const [errorNoHayInfraccion, setErrorNoHayInfraccion] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [errores, setErrores] = useState(0);
  const { handlerModal } = useGeneralAppStore()

  useEffect(() => {
    if (MODE === 'production') {
      handleIngresoApp();
    }
  }, []);

  useEffect(() => {
    if (errores >= 3) {
      toast.error('Excedio el número de intentos', toastOptions);
      handlerModal({ modal: false, modalName: "captcha" })
      setTimeout(() => {
        window.location.reload();
      }, 2000)
    }
  }, [errores])

  return (
    <>
      <div style={{ width: "100%" }}>
        <img src={encabezado} style={{ width: "100%" }} />
      </div>


      <div className="container pt-5 pb-5">
        <div className="p-2 bg-white rounded offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1 ">
          <div className="p-4  position-relative">
            {
              loads.includes('guardar_correo') &&
              <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)", left: "0", top: "0" }}>
                <MuniSpinner2 />
              </div>
            }
            <h5 className="mb-3">Consultas de Infracciones de Tránsito (por fotomultas)</h5>

            <hr />

            {infracciones.length === 0 && !errorNoHayInfraccion ? (
              <FormBusquedaPorDominio
                setInfracciones={setInfracciones}
                setErrorNoHayInfraccion={setErrorNoHayInfraccion}
                setCountdown={setCountdown}
                setValor={setValor}
                setDatosSobre={setDatosSobre}
                setCorreoElectronico={setCorreoElectronico}
                setConstancia={setConstancia}
              />
            ) : (
              <Button
                className="position-relative w-100 h-100"
                onClick={() => {
                  setErrorNoHayInfraccion("");
                  setInfracciones([]);
                  setValor(null);
                  setDatosSobre(null);
                  setCorreoElectronico(null)
                  setConstancia(null)
                }}
                disabled={countdown > 0}
              >
                {/* <div
                    className="position-absolute w-100 h-100 top-0 left-0"
                    style={{ display: countdown > 0 ? "block" : "none", marginLeft: '-12px' }}
                  >
                    <ProgressBar
                      animated
                      now={countdown * 20}
                      style={{ width: "100%", height: "100%", opacity: 0.5 }}
                    />
                  </div> */}
                <p className="mb-0">
                  Realizar otra consulta {countdown > 0 ? <>({countdown})</> : null}
                </p>
              </Button>
            )}

            {errorNoHayInfraccion && (
              <>

                <div
                  className="mt-3 alert alert-success d-flex align-items-center gap-2"
                  role="alert"
                >
                  <CheckIcon />
                  <p className="mb-0 fw-semibold">
                    No se detectaron infracciones {stringMensajePara(valor, datosSobre)}
                  </p>
                </div>
                <hr />
                {constancia && (
                  <>
                    <div className="d-flex justify-content-center">
                      <a
                        href={constancia}
                        download={"CONSTANCIA_CONSULTA_INFRACCIONES_TRANSITO.pdf"}
                        className="btn btn-primary fw-semibold shadow-sm px-4 py-2"
                      >
                        Descargar CONSTANCIA CONSULTA INFRACCIONES TRANSITO
                      </a>
                      {/* <object data={constancia} type="application/pdf" width="100%" height="100%"></object> */}
                    </div>
                    <hr />
                  </>
                )}
                <p className="fw-bold">Si usted supone que ha cometido una infracción solicitamos reingresar su consulta en el término mínimo de 48 horas, ya que la misma puede estar aún en el proceso de verificación</p>

                {valor && valor.length < 10 && datosSobre && (
                  <div className="mb-3">
                    <hr />
                    <FormGuardarCorreo
                      valor={valor}
                      datosSobre={datosSobre}
                      setValor={setValor}
                      setDatosSobre={setDatosSobre}
                      setCorreoElectronico={setCorreoElectronico}
                      verify={verify}
                      setVerify={setVerify}
                    />
                  </div>
                )}
              </>
            )}

            {infracciones.length > 0 ? (
              <div>
                <div
                  className="mt-3 alert alert-danger d-flex align-items-center gap-2"
                  role="alert"
                >
                  <BanIcon />{" "}
                  <p className="mb-0 fw-semibold">
                    Se detectó una infracción {stringMensajePara(valor, datosSobre)}
                  </p>
                </div>

                <div>
                  <p className="fw-semibold">¿Dónde puedo ver mi infracción de tránsito?</p>
                  <ul>
                    <li>
                      Deberá ingresar a su cuenta personal de{" "}
                      <a
                        href="https://weblogin.neuquencapital.gov.ar/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Muni Express
                      </a>
                      . Si no tiene una, podrá crearla de forma fácil teniendo el documento en mano.
                    </li>
                    <li>
                      Se le pedirá un domicilio real, número telefónico y un e-mail en el cual
                      deberá ser verificado desde su casilla de correo.
                    </li>
                    <li>
                      Dentro de la sección Domicilio Electrónico usted podrá visualizar el acta de
                      infracción y acceder al pago voluntario en caso que corresponda.
                    </li>
                  </ul>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {modals.includes('captcha') && <ModalCaptcha datosSobre={datosSobre} valor={valor} setDatosSobre={setDatosSobre} setValor={setValor} correoElectronico={correoElectronico} setCorreoElectronico={setCorreoElectronico} setVerify={setVerify} setErrores={setErrores} errores={errores} />}
      </div>
    </>
  );
};

export default BuscarInfracciones;
